
<template>
  <div>
    <hearderCommon :text="text"></hearderCommon>
    <div id="viewerContainer" ref="container" @scroll="orderScroll">
      <div id="viewer" class="pdfViewer">
        <div class="page" v-for="item in numPages" :key="item" :style="zoomArr[zoom]">
          <div class="canvasWrapper" :style="zoomArr[zoom]"></div>
          <div class="loadingIcon"></div>
        </div>
      </div>
    </div>

    <footer class="footer">
      <div class="footer-wrapper">
        <button class="toolbarButton pageUp" @click="pageUp"></button>
        <div class="pageNumber" @click="calcOffset">{{currentPageNum+1}}/{{numPages}}</div>
        <button class="toolbarButton pageDown" @click="pageNext"></button>
        <button class="toolbarButton zoomOut" @click="scaleMinus"></button>
        <button class="toolbarButton zoomIn" @click="scalePlus"></button>
        <button class="toolbarButton zoomIn downlow" @click="down">
          <!-- <van-icon name="upgrade" class="down"/> -->
          下载
        </button>
      </div>
    </footer>

    <div class="loading-wait" v-if="!pdf">
      <div class="loading-wait-mask"></div>
      <div class="loading-content">
        <div class="loading-gif">
          <img src="./images/loading.gif" style="width:50px;height:50px" />
        </div>
        <div>进度：{{loadProccess?loadProccess:'20'}}%</div>
        <div class="text">加载中，请耐心等待...</div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import PDFJS from "pdfjs-dist";
import hearderCommon from "../common/headerCommon";
import { TextLayerBuilder } from "pdfjs-dist/web/pdf_viewer";
PDFJS.GlobalWorkerOptions.workerSrc = "pdfjs-dist/build/pdf.worker.js";
let zoomConfig = [
  { width: "198px", height: "391px" },
  { width: "300px", height: "520px" },
  { width: "400px", height: "630px" },
  { width: "500px", height: "780px" },
  { width: "600px", height: "890px" },
  { width: "700px", height: "930px" },
  { width: "800px", height: "1060px" },
  { width: "900px", height: "1200px" },
  { width: "1000px", height: "1300px" },
  // { width: "1092px", height: "1192px" },
  // { width: "1291px", height: "1409px" },
  // { width: "1490px", height: "1626px" },
  // { width: "1688px", height: "1842px" },
  // { width: "1887px", height: "2102px" }
];
/* eslint-disable */

export default {
  components: {
    hearderCommon,
  },
  data() {
    return {
      // url: 'http://image.damoxueyuan.com/files/4%E3%80%81%E6%89%BF%E8%AF%BA%E5%87%BD.pdf',
      url:
        "http://image.damoxueyuan.com/files/6%E3%80%81%E5%8F%91%E8%A1%8C%E6%96%B9%E8%B5%84%E6%96%99.pdf",
      // url: 'http://image.damoxueyuan.com/file%E6%80%8E%E4%B9%88%E6%8A%8APDF%E8%BD%AC%E6%88%90%E5%9B%BE%E7%89%87%EF%BC%9FPDF%E8%BD%AC%E5%9B%BE%E7%89%87%E6%9C%89%E5%93%AA%E4%BA%9B%E5%B0%8F%E6%8A%80%E5%B7%A7%EF%BC%9F.pdf',
      // http://image.damoxueyuan.com/files/7%E3%80%81%E6%8B%85%E4%BF%9D%E6%96%B9%E8%B5%84%E6%96%99.pdf,
      container: null,
      scaleObj: {},
      numPages: 0,
      scale: 1.5,
      canvasList: [],
      zoomArr: zoomConfig,
      zoom: 1,
      text: "预览",
      pageArr: [],
      canvasWidth: 375,
      currentPageNum: 0,
      minWidth: 250,
      lastOffsetTop: 0, //距顶上次一次
      currentOffsetTop: 0, //距顶这一次
      pdf: null,
      loadProccess: 0
    };
  },
  mounted() {
    this.$nextTick(() => {
      // this.initPDF();
      this.initPDFByNew();
    });
    // this.url =  'http://localhost:8033/preview?url='+this.$route.query.url
    this.url = this.$route.query.url;
  },
  methods: {
    pageUp() {
      let currentPageNum = this.currentPageNum - 1;
      if (currentPageNum < 0) {
        return;
      }

      let pages = this.pageArr.length
        ? this.pageArr
        : this.$refs.container.querySelectorAll(".page");
      let toElement = pages[currentPageNum];
      toElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      });
      // this.currentPageNum = currentPageNum;
    },
    pageNext() {
      let currentPageNum = this.currentPageNum + 1;
      if (currentPageNum === this.numPages) {
        return;
      }
      let pages = this.pageArr.length
        ? this.pageArr
        : this.$refs.container.querySelectorAll(".page");

      // let pages[currentPageNum];
      let toElement = pages[currentPageNum];
      toElement.scrollIntoView({
        block: "center",
        behavior: "smooth"
      });
      // this.currentPageNum = currentPageNum;
    },
    down() {
      window.open(this.url);
    },
    getFirstOffset() {
      // 第一个元素该移动的距离
      //当前页高度
      let zoomHeight = +this.zoomArr[this.zoom]["height"].slice(0, -2);
      // 可视高度
      let clientHeight = this.$refs.container.clientHeight;
      // 第一个元素该移动的距离
      return (clientHeight - zoomHeight - 11) / 2;
    },
    isLastPage() {},
    calcOffset() {
      let a = this.$refs.container.scrollHeight;
      let b = this.$refs.container.clientHeight;
      let c = this.$refs.container.scrollTop;
      //当前页高度
      let zoomHeight = +this.zoomArr[this.zoom]["height"].slice(0, -2);

      // console.log("滚动条", a);
      // console.log("可视区", b);
      // console.log("PDF高度", zoomHeight);

      // console.log("距离顶部", c);

      // console.log("变化结果师", this.currentOffsetTop - this.lastOffsetTop);
      // console.log("======================结束");

      this.lastOffsetTop = this.currentOffsetTop;
    },
    scrollToPage() {
      // 滚动条总高度/总页数 = 每页高度
      // 距离顶部/每页高度 = 当前页  关键

      // 获得第一个该移动的位置
      let firstOffset = this.getFirstOffset();
      // 最后一页和第一页，作特殊处理
      // 距顶部高度
      let offsetTop = this.$refs.container.scrollTop + firstOffset;
      //当前页高度
      let zoomHeight = +this.zoomArr[this.zoom]["height"].slice(0, -2);
      this.currentPageNum = Math.round(offsetTop / (zoomHeight + 11));
    },
    orderScroll(e) {
      this.scrollToPage();
    },
    initPDFByNew() {
      let loadingTask = PDFJS.getDocument(this.url);
      loadingTask.onProgress = progress => {
        var percent = parseInt((progress.loaded / progress.total) * 100);
        // $('#' + transfer_id).css('width', percent + '%');
        this.loadProccess = percent;
      };
      loadingTask.promise.then(pdf => {
        this.pdf = pdf;
        // load pdf
        this.numPages = this.pdf.numPages;
        this.container = this.container || document.querySelector("#container");
        this.handlePDFPage();
      });
    },
    async initPDF() {
      //  读取PDF文档
      this.pdf = await this.getPDF(this.url);
      this.numPages = this.pdf.numPages;
      this.container = this.container || document.querySelector("#container");
      this.handlePDFPage();
    },

    refreshShow() {
      let currentZoom = this.zoomArr[this.zoom];
      this.canvasList.map(canvas => {
        canvas.style.width = currentZoom.width;
        canvas.style.height = currentZoom.height;
      });
    },

    scaleMinus() {
      if (this.zoom === 0) return;
      this.zoom--;
      this.refreshShow();
    },
    scalePlus() {
      if (this.zoom === this.zoomArr.length - 1) return;
      this.zoom++;
      this.refreshShow();
    },

    async handlePDFPage() {
      //开始处理PDF循环,异步渲染
      // console.log(this.numPages);

      // this.numPages -1
      for (let i = 0; i <= this.numPages; i++) {
        try {
          await this.rendPDF(this.pdf, i);
          // setTimeout(() => {
          // this.rendPDF(this.pdf, i);
          // }, 0);
        } catch (e) {
          // console.error(e)
        }
      }
    },

    async getPDF(url) {
      // 读取pdf文档
      let pdf = await PDFJS.getDocument(url);
      return pdf;
    },

    createWrapperDom(page) {
      let pageDiv = document.createElement("div");
      pageDiv.setAttribute("id", "page-" + (page.pageIndex + 1));
      pageDiv.setAttribute("data-page-number", page.pageIndex + 1);
      pageDiv.setAttribute("data-loaded", true);

      let canvasWrapper = document.createElement("div");
      pageDiv.appendChild(canvasWrapper);
    },

    async rendPDF(pdf, num) {
      // debugger;
      // console.log(num);

      let page = await pdf.getPage(num);
      // 设置展示比例
      let scale = 1.5;
      let viewport = page.getViewport(scale);
      // viewport.height = 1998;
      // viewport.width = 2219;

      // let pageDiv = document.createElement('div');
      // pageDiv.setAttribute('id', 'page-' + (page.pageIndex + 1));
      // pageDiv.setAttribute('style', 'position: relative');
      let pageDiv = document.createElement("div");
      pageDiv.setAttribute("id", "page-" + (page.pageIndex + 1));
      pageDiv.setAttribute("data-page-number", page.pageIndex + 1);
      pageDiv.setAttribute("data-loaded", true);

      // let canvasWrapper = document.createElement('div');
      //     pageDiv.setAttribute('class', 'canvasWrapper');
      //     pageDiv.appendChild(canvasWrapper);

      //     document.querySelector('#viewer').appendChild(canvasWrapper);

      // console.log(1111,this.$refs['pageIndex'+num]);
      let pageArr = this.pageArr.length
        ? this.pageArr
        : this.$refs.container.querySelectorAll(".page");
      let canvasWrapper = pageArr[num - 1].querySelector(".canvasWrapper");
      let loadingIcon = pageArr[num - 1].querySelector(".loadingIcon");
      loadingIcon.style.display = "none";

      this.pageArr = pageArr;

      //  debugger;
      let canvas = document.createElement("canvas");
      canvasWrapper.appendChild(canvas);
      let context = canvas.getContext("2d");
      canvas.height = viewport.height;
      canvas.width = viewport.width;
      // console.log(viewport);

      this.canvasList.push(canvas);

      let renderContext = {
        canvasContext: context,
        viewport: viewport
      };

      await page.render(renderContext).promise;
      this.refreshShow();
    }
  }
};
</script>

<style scoped>
/* 翻页页面 */
.loading-wait {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
}
.loading-wait-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #000;
  opacity: 0.8;
}
.loading-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: #fff;
}
.page {
  margin: 1px auto -8px auto;
  border: 9px solid transparent;
  background-clip: content-box;
  border-image: url(images/shadow.png) 9 9 repeat;
}
.page .loadingIcon {
  width: 100vw;
  height: 100vh;
  position: relative;
  background-size: 100px 100px;
  background-position: center center;
  background-image: url(images/loading.gif);
  background-repeat: no-repeat;
}
#viewerContainer {
  position: absolute;
  overflow: auto;
  width: 100%;
  top: 0;
  bottom: 49px;
  left: 0;
  right: 0;
}

canvas {
  margin: auto;
  display: block;
}

/* 底部导航条 */
footer {
  height: 49px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
.footer-wrapper {
  height: 100%;
  width: 100%;

  background-image: url(images/toolbar_background.png);
  box-shadow: 0 5px 8px rgba(50, 50, 50, 0.75);
  display: flex;
}
.toolbarButton,
.pageNumber {
  flex: 1;
  border: none;
  outline: none;
}
.pageNumber {
  width: 35%;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  background-color: transparent;
}
.toolbarButton.pageUp {
  background-image: url(images/icon_previous_page.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
  /* transform: rotate(270deg);
  transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -moz-transform: rotate(270deg); 
  -webkit-transform: rotate(270deg); 
  -o-transform: rotate(270deg);  */
}

.toolbarButton.pageDown {
  background-image: url(images/icon_next_page.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
  /* transform: rotate(270deg);
  transform: rotate(270deg);
  -ms-transform: rotate(270deg);
  -moz-transform: rotate(270deg); 
  -webkit-transform: rotate(270deg); 
  -o-transform: rotate(270deg);  */
}

.toolbarButton.zoomOut {
  background-image: url(images/icon_zoom_out.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
}

.toolbarButton.zoomIn {
  background-image: url(images/icon_zoom_in.png);
  background-repeat: no-repeat;
  background-position: center center;
  background-color: transparent;
}

.toolbarButton[disabled] {
  opacity: 0.3;
}
/* 底部导航条 */
.page[data-v-3723fa28] {
  border: 0;
  padding: 12px;
}

.footer-wrapper[data-v-3723fa28] {
  background: linear-gradient(
    180deg,
    rgba(172, 219, 86, 1) 0%,
    rgba(116, 180, 43, 1) 100%
  );
}
.down {
  transform: rotate(180deg) scale(1.7);
  color: #fff;
}
.downlow {
  background-image: none !important;
  font-weight: 500;
  font-size: 16px;
  line-height: 49px;
  color: #fff;
}
#viewerContainer[data-v-3723fa28]{
  padding-top: 40px;
}
</style>
